import React, { useContext, useState } from 'react'
import Home from './Home'
import { FloatButton, Modal, Tabs } from 'antd';
// import 'antd/dist/antd.css';
import { QrcodeOutlined } from '@ant-design/icons';
import { MdOutlineFeedback } from 'react-icons/md'
import { HiOutlineSignal } from "react-icons/hi2";
import { RiHome5Line } from 'react-icons/ri'
import { IoPersonCircleOutline, IoShareOutline } from 'react-icons/io5'
import About from './About';
import LiveUpdates from './LiveUpdates';
import Contact from './Contact';
import { IoMdShare } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { FaLocationArrow, FaPlus } from 'react-icons/fa';
import { BsGlobe } from 'react-icons/bs';
import { CardContext } from '../../store/CardContext';
import { saveAs } from "file-saver";
import Footer from './Footer';
import AddToGoogleWallet from '../addToWallet/AddToGoogleWallet';
import AddToAppleWallet from '../addToWallet/AddToAppleWallet';



const { TabPane } = Tabs;

function AutoBiography() {

    const [activeTabKey, setActiveTabKey] = useState("1");
    const [qrModal, setQrModal] = useState(false);

    const [cardData] = useContext(CardContext)
    // console.log(cardData, 'cardData');
    const { colors, personalInfo, QRCode, websites, vCard, _id } = cardData
    const footerText = true
    const bgColor = colors?.bgColor ? colors?.bgColor : "white"
    const navColor = colors?.navColor ? colors?.navColor : "#F57317"
    const navTxtColor = colors?.navTxtColor ? colors?.navTxtColor : "black"
    const activeTabColor = colors?.primaryColor ? colors?.primaryColor : "blue"
    const txtColor = colors?.txtColor ? colors?.txtColor : "black"



    const renderTabContent = () => {
        switch (activeTabKey) {
            case "1":
                return <div ><Home /></div>;
            case "2":
                return <div><LiveUpdates /></div>;
            case "3":
                return <div><About /></div>;
            case "4":
                return <div><Contact /></div>;
            default:
                return null;
        }
    };
    const iconStyle = {
        fontSize: '24px',
        marginRight: "0px",
        // color: navTxtColor
        // Adjust the size as needed
    };

    const handleShare = () => {
        if (navigator.share) {
            navigator
                .share({
                    text: "Please check it out.",
                    url: window.location.href,
                    title: "ZEEQR Biography",
                })
                .then(() => console.log("Successful share"))
                .catch((error) => console.log("Error sharing", error));
        }
    };



    const handleDownload = () => {
        let url = QRCode;
        saveAs(url, 'AutoBiographyQR-' + personalInfo?.name);
    };

    const floatButtonStyle = {
        color: 'white',
        // backgroundColor: '#ff6600', // Custom background color
        // border: 'none',
        // boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)', // Custom shadow
    };

    const innerButtonStyle = {
        // backgroundColor: 'black',
        color: 'white',
        border: 'none',
    };
    const innerButtonStyle1 = {
        // backgroundColor: 'black',
        color: 'white',
        border: 'none',
        marginBottom: "20px"
    };

    return (
        <div>
            <FloatButton.Group
                style={{
                    // position: 'fixed',
                    // bottom: '40px',
                    // right: '50px',
                    ...floatButtonStyle,
                }}
                className='fixed bottom-32 md:bottom-4 right-5'
                trigger="click"
                icon={<IoShareOutline style={{ color: 'black' }} size={20} />}
            >
                <FloatButton
                    style={innerButtonStyle}
                    tooltip="Share"
                    icon={<IoMdShare />}
                    onClick={handleShare}
                />
                {websites?.website[0]?.websiteUrl &&
                    <Link to={websites?.website[0]?.websiteUrl} target="_blank" className='my-2' >
                        <FloatButton
                            tooltip="Website"
                            style={innerButtonStyle1}
                            icon={<BsGlobe />}
                        />
                    </Link>
                }
                {personalInfo?.locationUrl &&
                    <Link to={personalInfo?.locationUrl} target="_blank" >
                        <FloatButton
                            style={innerButtonStyle1}
                            tooltip="Direction"
                            icon={<FaLocationArrow />}
                        />
                    </Link>
                }
                {vCard &&
                    <Link to={vCard} >
                        <FloatButton
                            style={innerButtonStyle1}
                            tooltip="Add To Contact"
                            icon={<FaPlus />}
                        />
                    </Link>
                }
                <FloatButton
                    style={innerButtonStyle}
                    tooltip="QR Modal"
                    icon={<QrcodeOutlined />}
                    onClick={() => setQrModal(true)}
                />



            </FloatButton.Group>


            <div className="flex items-center justify-center">
                <Tabs defaultActiveKey="1" centered onChange={key => setActiveTabKey(key)} style={{ background: navColor }} className="navbar  fixed z-50 bottom-10 shadow-lg backdrop-blur-39 flex justify-around items-center z-5 max-w-[360px] h-[74px] px-[16px]  rounded-full mx-auto left-8 right-8 md:left-20 md:right-20" >
                    <TabPane
                        tab={
                            <span className='flex flex-col items-center'
                                style={{ color: activeTabKey === '1' ? activeTabColor : navTxtColor }}
                            >
                                <RiHome5Line style={iconStyle} />
                                HOME
                            </span>
                        }
                        key="1"
                    />
                    <TabPane
                        tab={
                            <span className='flex flex-col items-center'
                                style={{ color: activeTabKey === '2' ? activeTabColor : navTxtColor }}
                            >
                                <HiOutlineSignal style={iconStyle} />
                                LIVE
                            </span>
                        }
                        key="2"
                    />
                    <TabPane
                        tab={
                            <span className='flex flex-col items-center'
                                style={{ color: activeTabKey === '3' ? activeTabColor : navTxtColor }}
                            >
                                <IoPersonCircleOutline style={iconStyle} />
                                ABOUT
                            </span>
                        }
                        key="3"
                    />
                    <TabPane
                        tab={
                            <span className='flex flex-col items-center'
                                style={{ color: activeTabKey === '4' ? activeTabColor : navTxtColor }}
                            >
                                <MdOutlineFeedback style={iconStyle} />
                                FEEDBACK
                            </span>
                        }
                        key="4"
                    />
                </Tabs>
            </div>
            <div className=' pb-32  max-w-[393px] mx-auto' style={{ background: bgColor }}>
                {renderTabContent()}
                {/*  --------------------------------- footer ---------------------------------  */}
                {footerText &&
                    <Footer color={txtColor} />
                }
            </div>

            <Modal title="Auto Biography QR Code" style={{ width: '300px' }} open={qrModal} onCancel={() => setQrModal(false)} footer={false}>
                <div className='flex flex-col items-center justify-center mt-5'>
                    <img
                        src={QRCode}
                        className="my-qr-code p-3 bg-white border-2 rounded-xl border-black"
                        width="200px"
                        alt=""
                    />
                    <p className="my-qr-download cursor-pointer mt-2" onClick={handleDownload}>
                        Download QR Code
                    </p>
                    <div className='flex justify-center gap-3 mt-10'>
                        <AddToGoogleWallet cardID={_id} />
                        <AddToAppleWallet cardID={_id} />

                    </div>
                </div>
            </Modal>

        </div>
    )
}

export default AutoBiography